import { Box, Typography, useTheme } from "@mui/material";
import FormActionButton from "../../buttons/formActionButton.component";
import { Add } from "@mui/icons-material";
import { useState } from "react";
import SubAreaDialog from "../../muiDialogs/subAreaDialog.component";
import SubAreaCard from "./subAreaCard.component";

const SubAreaForm = ({
  fieldsType,
  formData,
  error,
  fieldPosition,
  onDataChange,
  onSubmit,
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [selectedSubArea, setSelectedSubArea] = useState(null);
  const [dialogKey, setDialogKey] = useState(0);

  const subAreas = formData || [];

  const handleOpenDialog = () => {
    setSelectedSubArea(null);
    setDialogKey((prev) => prev + 1);
    setOpen(true);
  };

  const handleEditSubArea = (subArea) => {
    setSelectedSubArea(subArea);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedSubArea(null);
  };

  const handleAddSubArea = (newSubArea) => {
    const updatedSubAreas = [...subAreas, { ...newSubArea, id: Date.now() }];
    onDataChange(updatedSubAreas);
  };

  const handleUpdateSubArea = (updatedSubArea) => {
    const updatedSubAreas = subAreas.map((area) =>
      area.id === updatedSubArea.id ? updatedSubArea : area
    );
    onDataChange(updatedSubAreas);
  };

  const handleDeleteSubArea = (subAreaId) => {
    const updatedSubAreas = subAreas.filter((area) => area.id !== subAreaId);
    onDataChange(updatedSubAreas);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (subAreas.length === 0) {
      console.warn("Nessuna sottoarea definita");
    }
    onSubmit(subAreas);
  };

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      gap={2}
      component="form"
      id="sub-areas-form"
      onSubmit={handleFormSubmit}
      overflow="auto"
      pb={2}
    >
      <Typography fontWeight="bold" fontSize="16px">
        Sottoterreni
      </Typography>
      <Typography fontSize="12px" color={theme.palette.custom.infoTextColor}>
        Cupidatat adipisicing et pariatur labore non in cillum anim. Ipsum ex
        sit velit exercitation sunt commodo officia id nisi Lorem. Quis
        incididunt ullamco esse laborum anim magna eu esse.
      </Typography>
      {Array.isArray(subAreas) && subAreas.length > 0
        ? subAreas?.map((subArea) => (
            <SubAreaCard
              key={subArea.id}
              theme={theme}
              savedData={subArea}
              onDelete={() => handleDeleteSubArea(subArea.id)}
              onEdit={() => handleEditSubArea(subArea)}
              fieldPosition={fieldPosition}
              fieldsType={fieldsType}
            />
          ))
        : null}

      <FormActionButton
        startIcon={<Add />}
        label="Aggiungi sottoterreno"
        onClick={handleOpenDialog}
        savedData={formData}
      />
      <SubAreaDialog
        key={dialogKey}
        open={open}
        onClose={handleCloseDialog}
        theme={theme}
        fieldsType={fieldsType}
        subAreaData={selectedSubArea}
        onSubAreaAdd={handleAddSubArea}
        onSubAreaUpdate={handleUpdateSubArea}
        error={error}
        subAreas={subAreas}
        fieldPosition={fieldPosition}
      />
    </Box>
  );
};

export default SubAreaForm;
